"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, // This upgrader helps to merge the duplicate plugins and recover the broken plugins
// and also adds a unique id to the plugin to avoid the duplicate plugins in the future
"default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _slack = /*#__PURE__*/ _interop_require_default(require("~/plugins/slack"));
const _teams = /*#__PURE__*/ _interop_require_default(require("~/plugins/teams"));
const _discord = /*#__PURE__*/ _interop_require_default(require("~/plugins/discord"));
const _twilioWhatsapp = /*#__PURE__*/ _interop_require_default(require("~/plugins/twilioWhatsapp"));
const _twilio = /*#__PURE__*/ _interop_require_default(require("~/plugins/twilio"));
const _s3 = /*#__PURE__*/ _interop_require_default(require("~/plugins/s3"));
const _minio = /*#__PURE__*/ _interop_require_default(require("~/plugins/minio"));
const _gcs = /*#__PURE__*/ _interop_require_default(require("~/plugins/gcs"));
const _mattermost = /*#__PURE__*/ _interop_require_default(require("~/plugins/mattermost"));
const _spaces = /*#__PURE__*/ _interop_require_default(require("~/plugins/spaces"));
const _backblaze = /*#__PURE__*/ _interop_require_default(require("~/plugins/backblaze"));
const _vultr = /*#__PURE__*/ _interop_require_default(require("~/plugins/vultr"));
const _ovhCloud = /*#__PURE__*/ _interop_require_default(require("~/plugins/ovhCloud"));
const _linode = /*#__PURE__*/ _interop_require_default(require("~/plugins/linode"));
const _upcloud = /*#__PURE__*/ _interop_require_default(require("~/plugins/upcloud"));
const _smtp = /*#__PURE__*/ _interop_require_default(require("~/plugins/smtp"));
const _mailerSend = /*#__PURE__*/ _interop_require_default(require("~/plugins/mailerSend"));
const _scaleway = /*#__PURE__*/ _interop_require_default(require("~/plugins/scaleway"));
const _ses = /*#__PURE__*/ _interop_require_default(require("~/plugins/ses"));
const _r2 = /*#__PURE__*/ _interop_require_default(require("~/plugins/r2"));
const _cli = require("~/cli");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const defaultPlugins = [
    _slack.default,
    _teams.default,
    _discord.default,
    _twilioWhatsapp.default,
    _twilio.default,
    _s3.default,
    _minio.default,
    _gcs.default,
    _mattermost.default,
    _spaces.default,
    _backblaze.default,
    _vultr.default,
    _ovhCloud.default,
    _linode.default,
    _upcloud.default,
    _smtp.default,
    _mailerSend.default,
    _scaleway.default,
    _ses.default,
    _r2.default
];
const logger = {
    log: (message)=>{
        console.log(`[0258003_ncDuplicatePluginMerge ${Date.now()}] ` + message);
    },
    error: (message)=>{
        console.error(`[0258003_ncDuplicatePluginMerge ${Date.now()}] ` + message);
    }
};
async function _default({ ncMeta }) {
    logger.log('Merging duplicate plugins and updating the plugin id');
    // get the plugins which are valid and matches the plugin title
    // update the plugin with the new id
    for (const pluginConfig of defaultPlugins){
        // get the valid plugin
        const currentPlugin = await ncMeta.knex(_cli.MetaTable.PLUGIN).where('title', pluginConfig.title).first();
        if (currentPlugin) {
            // update the plugin with the new id
            await ncMeta.knex(_cli.MetaTable.PLUGIN).where('id', currentPlugin.id).update({
                id: pluginConfig.id
            });
            currentPlugin.id = pluginConfig.id;
        }
        if (pluginConfig.recoveryTitle) {
            // get the plugin with old title
            const oldPlugin = await ncMeta.knex(_cli.MetaTable.PLUGIN).where('title', pluginConfig.recoveryTitle).first();
            // if the old plugin is not present then continue
            if (!oldPlugin) continue;
            if (currentPlugin) {
                // if the old plugin is present then update the new plugin with the old plugin configuration
                // and only if new plugin is not configured or active
                if (!currentPlugin.active && (oldPlugin == null ? void 0 : oldPlugin.active) || !currentPlugin.input && (oldPlugin == null ? void 0 : oldPlugin.input)) {
                    await ncMeta.knex(_cli.MetaTable.PLUGIN).update({
                        input: oldPlugin.input,
                        active: currentPlugin.active || oldPlugin.active
                    })// use the new plugin id since it's already updated at the start
                    .where('id', pluginConfig.id);
                    logger.log(`Merged the old plugin with the new plugin: ${pluginConfig.id}`);
                }
                if (oldPlugin) {
                    // delete the old plugin
                    await ncMeta.knex(_cli.MetaTable.PLUGIN).where('id', oldPlugin.id).delete();
                    logger.log(`Deleted the old duplicate plugin: ${oldPlugin.title}`);
                }
            } else {
                // if new plugin is not present then update the old plugin with the new id
                // we can skip rest of the props since it will get updated from the existing plugin initialization
                await ncMeta.knex(_cli.MetaTable.PLUGIN).where('id', oldPlugin.id).update({
                    id: pluginConfig.id
                });
                logger.log(`Updated the old plugin id: ${pluginConfig.id}`);
            }
        }
    }
    logger.log('Merging duplicate plugins and updating the plugin id completed');
}
